import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import VuetifyConfirm from 'vuetify-confirm'

const vuetify = new Vuetify({
  icons: {
    iconfont: 'md',
  },
  options: {
    minifyTheme: (css) => (process.env.NODE_ENV === 'production' ? css.replace(/[\s|\r\n|\r|\n]/g, '') : css),
  },
})

Vue.use(Vuetify)

Vue.use(VuetifyConfirm, {
  vuetify,
  color: '#004f9f',
  icon: '',
  width: 450,
  property: '$confirm',
})

export default vuetify
